import initReactApp from 'dpl/util/initReactApp';
import PaymentRequestModalV2 from 'dpl/components/PaymentRequest/New/PaymentRequestModalV2';
import StripeChargeUserHeaderMenu from 'dpl/components/StripeCharge/New/StripeChargeUserHeaderMenu';

initReactApp({
  StripeChargeUserHeaderMenu,
  PaymentRequestModalV2
});
